import React, { Dispatch, SetStateAction } from 'react';
import { useRecoilState } from 'recoil';
import { Typography, SelectionGroup, SelectionGroupItem } from 'fronton-react';
import { useFormContext } from 'react-hook-form';
import { TInputParams } from 'entries/common/widgets/context';
import { getCalculatedRooms } from 'pages/dimensions/helpers/get-calculated-rooms.helper';
import { activeRoomId, calculatedRoomsParams, roomArea } from 'pages/dimensions/store/area';
import { getAreaState } from 'pages/dimensions/helpers/get-area';
import { ParametersEnum } from 'pages/dimensions/types';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { TRoomsParams } from 'common/types/floor-params.type';
import { getSelectionGroupSize, getFormattedSquare, getClearedRoomParams } from './helpers';
import { useFilteredInputParams } from '../../forms/hooks/use-filtered-input-params';
import { ThicknessLabel } from '../../forms/layer-thickness/const';
import {
  RoomsParamsContainer,
  CalculatedRoomsContainer,
  SelectionGroupClassname,
  RoomParametersWrapper,
  SelectionGroupItemClassname,
} from './styles';

type TProps = {
  setInputParams: Dispatch<SetStateAction<TInputParams>>;
  setActiveTabIndex: Dispatch<SetStateAction<number>>;
};
export const SavedRooms = ({ setInputParams, setActiveTabIndex }: TProps) => {
  const { setValue, clearErrors } = useFormContext();
  const [selectedRoomId, setSelectedRoomId] = useRecoilState(activeRoomId);
  const [, setIsAreaEnabled] = useRecoilState(roomArea);
  const { mobile } = useBreakpoints() ?? {};
  const calculatedRooms = getCalculatedRooms();
  const [, setCalcuLatedRoomParams] = useRecoilState<TRoomsParams>(calculatedRoomsParams);

  const { defaultInputParams } = useFilteredInputParams();

  const changeInputsParams = (isEnabled: boolean) => {
    const areaState = getAreaState({
      inputParams: defaultInputParams,
      isEnabled,
    });

    setInputParams(areaState);
  };

  const handleClickRoomParamsBtn = (room: TRoomsParams) => {
    const { isCalculatedRoomsParamsHasOnlySquare, width, length, square } = getClearedRoomParams(room);
    setValue(ParametersEnum.width, width);
    setValue(ParametersEnum.length, length);
    setValue(ParametersEnum.area, square);
    if (width === '' && length === '') {
      setActiveTabIndex(1);
    } else {
      setActiveTabIndex(0);
    }
    setCalcuLatedRoomParams(room);
    changeInputsParams(isCalculatedRoomsParamsHasOnlySquare);
    setIsAreaEnabled(isCalculatedRoomsParamsHasOnlySquare);
    setSelectedRoomId(room.id);
    clearErrors([ParametersEnum.width, ParametersEnum.length, ParametersEnum.area]);
  };

  return (
    <RoomsParamsContainer>
      <CalculatedRoomsContainer data-testid="calculated-rooms-container">
        <SelectionGroup
          active={selectedRoomId}
          onChange={() => {
            // This is intentional
          }}
          variant="composite"
          size={getSelectionGroupSize(mobile)}
          className={SelectionGroupClassname}>
          {calculatedRooms.map((room, i) => {
            const formattedSquare = getFormattedSquare(room);
            return (
              <SelectionGroupItem
                data-testid={`button-with-room-params-${i}`}
                key={room.id}
                value={room.id}
                onClick={() => handleClickRoomParamsBtn(room)}
                className={SelectionGroupItemClassname}>
                <RoomParametersWrapper>
                  <Typography size="body_accent" variant="m">
                    Комната {formattedSquare} м²
                  </Typography>
                  <Typography size="body_long" variant="s" color="text-minor">
                    {ThicknessLabel[room.typeInstallation as 'horizontal' | 'diagonal']}
                  </Typography>
                </RoomParametersWrapper>
              </SelectionGroupItem>
            );
          })}
        </SelectionGroup>
      </CalculatedRoomsContainer>
    </RoomsParamsContainer>
  );
};
